import { PANE_ORDER } from '../components/map/MapAnchors';
import { LAYER_CONFIGS } from '../constants/general';

export const getLineStringColor = (id, value) => {
  switch (id) {
    case 'tornadoPathsHazard':
      return tornadoColorPalette[value];
    case 'hailPathsHazard':
      return hailColorPalette[value];
    case 'hurricaneTracksHazard':
      return hurricaneColorPalette[value];
    case 'flowlines':
      return flowlinesColor['flowlines'];
    default:
      return null;
  }
};

export const getMultiPolygonColor = (id, value) => {
  switch (id) {
    case 'oneHundredYearWindGustHazard':
    case 'twoHundredYearWindGustHazard':
    case 'fiveHundredYearWindGustHazard':
      // Convert the wind speed value to a color palette index
      const windColorIndex = getWindSpeedColorIndex(value);
      return windColorPalette[windColorIndex];
    case 'WUI':
      return wuiColorPalette[value];
    default:
      return null;
  }
};

// Function to map wind speed values to color palette indices
const getWindSpeedColorIndex = windSpeed => {
  if (windSpeed < 40) return 0;
  if (windSpeed < 60) return 1;
  if (windSpeed < 80) return 2;
  if (windSpeed < 100) return 3;
  if (windSpeed < 120) return 4;
  if (windSpeed < 140) return 5;
  return 6;
};

export const flowlinesColor = {
  flowlines: '#264F89',
};

// Blue Color Palette (0-6 intensity levels)
export const hailColorPalette = {
  0: '#BEE0FB',
  1: '#839DBE',
  2: '#4D567E',
  3: '#BC86BE',
  4: '#936193',
  5: '#DDA0B0',
  6: '#A72649',
};

export const hurricaneColorPalette = {
  Disturbance: '#c7fef5ff',
  'Tropical Depression': '#a2f5e7ff',
  'Tropical Storm': '#74E8D4',
  Subtropical: '#74E8D4',
  Category1: '#58BCF2',
  Category2: '#F0BE63',
  Category3: '#F25B5E',
  Category4: '#BF55AB',
  Category5: '#51479B',
  'Post-tropical': '#040025ff',
};

export const tornadoColorPalette = {
  0: '#94A6BD',
  1: '#484467',
  2: '#628A7E',
  3: '#FAF1C3',
  4: '#E77A62',
  5: '#913427',
};

// Alternative Blue Palette (ocean themed)
export const windColorPalette = {
  0: '#FEF0FE', // Sky blue (darker, visible on white background)
  1: '#D4B8D4', // Steel blue
  2: '#B89DB9', // Dodger blue
  3: '#9D839E', // Bright blue
  4: '#6A516A', // Medium navy
  5: '#513A52', // Navy blue
  6: '#3A243B', // Darkest blue
};

export const windSpeedPaletteForLegend = {
  '<40': '#FEF0FE',
  '40-60': '#D4B8D4',
  '60-80': '#B89DB9',
  '80-100': '#9D839E',
  '100-120': '#6A516A',
  '120-140': '#513A52',
  '140+': '#3A243B',
};

export const wuiColorPalette = {
  High_Dens_Interface: '#03071E',
  High_Dens_Intermix: '#370D25',
  High_Dens_NoVeg: '#600E22',
  Low_Dens_Interface: '#750A10',
  Low_Dens_Intermix: '#971013',
  Low_Dens_NoVeg: '#BC1B1D',
  Med_Dens_Interface: '#DC3323',
  Med_Dens_Intermix: '#F04928',
  Med_Dens_NoVeg: '#F85C2C',
  Uninhabited_NoVeg: '#FA7B31',
  Uninhabited_Veg: '#FA9B3E',
  Very_Low_Dens_NoVeg: '#F9BA5C',
  Very_Low_Dens_Veg: '#FBD577',
  Water: '#FEEE90',
};

export const getContourColor = basemapInfo => {
  return basemapInfo === 'light' ? '#555555' : basemapInfo === 'dark' ? '#ffffff' : '#fc8c03';
};

// Structure icon badges invert on satellite so they stand out against busy imagery
export const getIconBadgeColors = basemapInfo =>
  basemapInfo === 'satellite'
    ? { badge: '#000000', glyph: '#ffffff', ring: '#ffffff', ringWidth: 2, haloWidth: 2 }
    : { badge: '#ffffff', glyph: '#000000', ring: '#000000', ringWidth: 1, haloWidth: 1.5 };

export const wuiPaletteForLegend = {};

// Get the beforeId for a layer based on its pane order
export const getBeforeIdForLayer = (layerId, map) => {
  const config = LAYER_CONFIGS[layerId];
  if (!config?.pane) return undefined;

  // Find this pane's index, then return the anchor for the NEXT pane up
  const idx = PANE_ORDER.indexOf(config.pane);
  if (idx === -1 || idx === PANE_ORDER.length - 1) return undefined;

  // Look forward to find the next anchor that actually exists on the map
  for (let i = idx + 1; i < PANE_ORDER.length; i++) {
    const nextAnchor = `anchor-${PANE_ORDER[i]}`;
    if (map?.getLayer?.(nextAnchor)) return nextAnchor;
  }
  return undefined;
};
